<template>
	<div class="container">
		<van-sticky>
		<div class="nav_box">
			<div class="nav_box_main">
				<!--顶部登录-->
				<div
					class="top_box"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div v-if="userMsg" class="login_box">
						<span class="msg" @click="goInfo">Hello, {{ userMsg }}</span>
						<span class="out" style="display: inline-block;margin-left: 10px;position: relative;top: 1px;" @click="logOut">
							<i class="el-icon-switch-button" style=""></i>
						</span>
					</div>
					<div v-if="!userMsg" class="login_box" @click="goSignIn">
						Sign in
					</div>
					<div v-if="false" class="lang_box">
						<span class="actived">EN</span>
						<span>CN</span>
					</div>
				</div>
				<!--顶部登录-->
				<!--导航-->
				<div class="bot_box">
					<div
						class="logo"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						@click="goHome"
					>
						<img src="../../assets/img/logo.png" />
					</div>
					<div
						class="nav_list"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="150"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div
							v-for="(value, index) in navList"
							:key="value.title"
							class="nav_el"
							:class="pagename == value.title ? 'actived' : ''"
							@mouseover="navOver(value)"
							@click="goNav(value)"
						>{{ value.title }}</div>
					</div>
					<div
						class="search_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="250"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="input_box">
							<input v-model="inputVal" placeholder="Search by Name, or Keyword" @keyup.enter="goSearch" />
							<van-icon name="search" class="icon" size="20" color="#006BB3" @click="goSearch" />
						</div>
						<div class="number_box" @click="goList">
							<img class="icon" src="../../assets/img/nav/icon_1.webp" />
							<van-badge :content="idsStr.length" max="99999" color="#E37542">
								<span class="tit">My List</span>
							</van-badge>
						</div>
					</div>
				</div>
				<!--导航-->
			</div>
		</div>
		<!--导航-->
		<div v-if="navShow" class="nav_show_box"
			data-aos="fade-in"
			data-aos-duration="400"
			data-aos-delay="0"
			data-aos-offset="0"
			data-aos-once="true"
		>
			<div class="nav_products_box" @mouseleave="navLeave">
				<div class="products_box_main"
					data-aos="fade-left"
					data-aos-duration="400"
					data-aos-delay="150"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="products_box_el">
						<!-- <div class="tit">Product Type</div> -->
						<div v-for="(value, index) in productType" :key="index" class="title" @click="goNavChild(1, value)">{{ value.title }}</div>
						<!-- <div class="title" @click="goNavChild(1, 'Devices')">Devices</div> -->
						<div class="title" @click="goNavChild(1, 'NC Membranes')">NC Membrane</div>
					</div>
					<div v-if="false" class="products_box_el" style="padding-top: 25px;">
						<!-- <div class="tit">Primary Diseases</div><br /> -->
						<div v-for="(value, index) in productList" :key="index" class="title" style="margin-top: 12px;" @click="goNavChild(2, value)">{{ value.title }}</div>
					</div>
				</div>
			</div>
		</div>
		</van-sticky>
	</div>
</template>

<script>
import { userCart } from '@/api/public';  //保存购物车
export default {
	props: ['pageName'],
	components:{
		//
	},
	data() {
		return {
			pagename: this.pageName,
			inputVal: '',
			navList: [],
			navActivedId: '',
			navShow: false,
			productType: [],
			productList: [],
			idsStr: [],
			ids: [],
			userMsg: localStorage.getItem('firstName') || localStorage.getItem('email')
		}
	},
	created(){
		let that = this;
		if(JSON.parse(localStorage.getItem('idsStr'))) {
			that.idsStr = JSON.parse(localStorage.getItem('idsStr')).split(',');
		}
		if(JSON.parse(localStorage.getItem('ids'))) {
			that.ids = JSON.parse(localStorage.getItem('ids')).split(',');
		}
		if(sessionStorage.getItem('navData')) {
			// that.navList = JSON.parse(sessionStorage.getItem('navData')).cate;
			that.navList = JSON.parse(sessionStorage.getItem('navData')).cate.filter(function(element) {
				return element.title !== 'Services';
			})
			that.productType = JSON.parse(sessionStorage.getItem('navData')).cate_list;
			that.productList = JSON.parse(sessionStorage.getItem('navData')).diseases_list;
		}
	},
	mounted() {
		let that = this;
	},
	methods: {
		//更新清单角标
		initCount() {
			let that = this;
			that.idsStr = [];
			that.ids = [];
			if(JSON.parse(localStorage.getItem('idsStr'))) {
				that.idsStr = JSON.parse(localStorage.getItem('idsStr')).split(',');
			}
			if(JSON.parse(localStorage.getItem('ids'))) {
				that.ids = JSON.parse(localStorage.getItem('ids')).split(',');
			}
		},
		//退出登录
		logOut() {
			let that = this;
			// that.$confirm('Do you want to log out?', 'Tips', {
			// 	confirmButtonText: 'Confirm',
			// 	cancelButtonText: 'Cancel',
			// 	type: 'warning'
			// }).then(() => {
				if(that.idsStr.length > 0 && that.ids.length > 0) {
					that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
					userCart({
						product_list: that.idsStr.join(','),
						product_id: that.ids.join(',')
					}).then(res => {
						that.$toast.clear();
						that.$toast('Exit successful');
						setTimeout(() => {
							localStorage.clear();
							sessionStorage.clear();
							that.goHome();
						}, 1000);
					});
				}else {
					that.$toast('Exit successful');
					setTimeout(() => {
						localStorage.clear();
						sessionStorage.clear();
						that.goHome();
					}, 1000);
				}
			// }).catch(() => {});
		},
		//点击进入完善信息
		goInfo() {
			if(this.$route.path != '/information') {
				this.$router.push({ path: '/information' });
			}else {
				window.location.reload();
			}
		},
		//点击搜索
		goSearch() {
			if(this.inputVal) {
				if(this.$route.path != '/products') {
					this.$router.push({ path: '/products', query: { search: this.inputVal } });
				}else {
					this.$router.push({ path: '/products', query: { search: this.inputVal } });
					window.location.reload();
				}
			}else {
				this.$toast('Please enter name, keywords or catalog number to search.');
			}
		},
		//点击进入清单
		goList() {
			if(this.$route.path != '/watch-list') {
				this.$router.push({ path: '/watch-list' });
			}else {
				window.location.reload();
			}
		},
		//点击登录
		goSignIn() {
			if(this.$route.path != '/sign-in') {
				this.$router.push({ path: '/sign-in' });
			}else {
				window.location.reload();
			}
		},
		//子导航点击
		goNavChild(type, value) {
			let that = this;
			if(that.$route.path != '/products') {
				if(type == 1) {
					if(value == 'NC Membranes') {
						window.open('https://i-membrane.com/');
					}else {
						that.$router.push({ path: '/products', query: { type: value.id } });
					}
				}else if(type == 2) {
					that.$router.push({ path: '/products', query: { disease: value.id } });
				}
			}else {
				if(type == 1) {
					if(value == 'NC Membranes') {
						window.open('https://i-membrane.com/');
					}else {
						that.$router.push({ path: '/products', query: { type: value.id } });
					}
				}else if(type == 2) {
					that.$router.push({ path: '/products', query: { disease: value.id } });
				}
				window.location.reload();
			}
		},
		//导航点击
		goNav(value) {
			let that = this;
			if(value.route != 'Careers') {
				if(value.url == '/products') {
					if(that.$route.path != value.url) {
						that.$router.push({ path: '/products' });
					}else {
						that.$router.push({ path: '/products' });
						setTimeout(() => {
							window.location.reload();
						}, 300);
					}
				}else {
					if(that.$route.path != value.url) {
						that.$router.push({ path: value.url });
					}else {
						window.location.reload();
					}
				}
			}else {
				window.open(value.url);
			}
		},
		//导航滑入
		navOver(value) {
			let that = this;
			if(value.title == 'Products') {
				that.navShow = true;
			}else {
				that.navShow = false;
			}
		},
		//子导航滑出
		navLeave() {
			let that = this;
			that.navShow = false;
		},
		//点击首页
		goHome() {
			if(this.$route.path != '/') {
				this.$router.push({ path: '/' });
			}else {
				window.location.reload();
			}
		}
	}
}
</script>

<style lang="less" scoped>
.nav_show_box{
	color: #000000;
	width: 100%;
	height: calc(100vh - 107px);
	position: absolute;
	top: 107px;
	left: 0;
	background-color: rgba(0,0,0,.7);
	z-index: 999;
	box-shadow: 0px 0px 20px 1px rgba(0,0,0,0.05);
	.nav_products_box{
		height: auto;
		background-color: #ffffff;
		overflow: auto;
		.products_box_main{
			width: 1140px;
			height: 100%;
			margin: 0 auto;
			padding: 50px 0 60px 0;
			.products_box_el{
				.tit{
					display: inline-block;
					padding-right: 20px;
					font-size: 18px;
					color: #808080;
				}
				.title:hover{
					color: rgb(227, 117, 66);
					border: 1px solid rgb(227, 117, 66);
				}
				.title{
					display: inline-block;
					margin: 0 16px 0 0px;
					padding: 8px 16px 5px 16px;
					border: 1px solid #CCCCCC;
					border-radius: 26px;
					cursor: pointer;
					user-select: none;
					font-size: 18px;
				}
			}
		}
	}
}
.nav_box{
	width: 100%;
	max-width: 1920px;
	margin: 0 auto;
	box-shadow: 0px 3px 1px 1px rgba(0,0,0,0.05);
	background-color: #ffffff;
	.nav_box_main{
		width: 1140px;
		margin: 0 auto;
		padding: 18px 0 0px 0;
		color: #000000;
		//导航
		.bot_box{
			display: flex;
			align-items: flex-start;
			padding-top: 15px;
			.nav_list{
				flex: 1;
				padding-left: 16px;
				.nav_el.actived{
					color: #E37542;
					border-bottom: 2px solid rgb(227, 117, 66);
				}
				.nav_el:hover{
					color: #E37542;
					border-bottom: 2px solid rgb(227, 117, 66);
				}
				.nav_el{
					display: inline-block;
					margin-left: 24px;
					padding-bottom: 18px;
					border-bottom: 2px solid transparent;
					font-size: 18px;
					cursor: pointer;
					user-select: none;
				}
			}
			.search_box{
				width: auto;
				position: relative;
				top: -6px;
				.number_box{
					display: inline-block;
					cursor: pointer;
					.tit:hover{
						color: #E37542;
						text-decoration: underline;
					}
					.tit{
						position: relative;
						top: 4px;
						font-size: 18px;
					}
					.icon{
						width: 32px;
					}
				}
				.input_box{
					display: inline-block;
					position: relative;
					margin-right: 24px;
					.icon{
						position: absolute;
						top: 6px;
						right: 5px;
						cursor: pointer;
					}
					input{
						width: 254px;
						height: 35px;
						padding: 4px 30px 0 10px;
						color: #006BB3;
						font-size: 16px;
						line-height: 35px;
						border-radius: 6px 6px 6px 6px;
						border: 1px solid #808080;
					}
				}
			}
			.logo{
				width: auto;
				position: relative;
				top: -11px;
				img{
					// width: 120px;
					height: 40px;
					cursor: pointer;
				}
			}
		}
		//顶部登录
		.top_box{
			text-align: right;
			.lang_box{
				display: inline-block;
				margin-left: 20px;
				padding: 3px 5px 0px 5px;
				border: 1px solid #AAAAAA;
				border-radius: 6px;
				span.actived{
					color: #ffffff;
					background-color: #E37542;
				}
				span{
					display: inline-block;
					padding: 4px 3px 0 3px;
					color: #AAAAAA;
					border-radius: 3px;
					line-height: 1;
					cursor: pointer;
					user-select: none;
				}
			}
			.login_box{
				display: inline-block;
				font-size: 18px;
				line-height: 1;
				cursor: pointer;
				user-select: none;
			}
			.msg:hover{
				color: #E37542;
				text-decoration: underline;
			}
			.out:hover{
				color: #E37542;
				text-decoration: underline;
			}
			// .login_box:hover{
			// 	color: #E37542;
			// 	text-decoration: underline;
			// }
		}
	}
}
</style>